import { chakra } from '@chakra-ui/react'
import { faDoorOpen } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import type { AugmentedWorldLevel } from '@/components/Worlds/UI/Level/types'

import type { UserDetails } from '../../types'
import { WORLD_LEVEL_TO_UI_DETAILS } from './constants'
import { getAugmentedWorldLevel } from './internal/helpers'

export default function LevelIcon({
  user,
  level,
}: {
  user: Pick<UserDetails, 'id' | 'roles'>
  level?: AugmentedWorldLevel | null
}): JSX.Element | null {
  const augmentedWorldLevel = getAugmentedWorldLevel({ user, level: level ?? null })

  if (augmentedWorldLevel == null) {
    return (
      <chakra.span color="fg.muted">
        <FontAwesomeIcon icon={faDoorOpen} fontSize="16px" color={chakraTokenToVar('fg.muted')} />
      </chakra.span>
    )
  }
  const { icon, iconColor } = WORLD_LEVEL_TO_UI_DETAILS[augmentedWorldLevel]

  return (
    <chakra.span color={iconColor}>
      <FontAwesomeIcon icon={icon} fontSize="16px" />
    </chakra.span>
  )
}
